import * as TWEEN from "@tweenjs/tween.js";
import * as THREE from "three";

export default class CameraAnimation {
    constructor(canvas) {
        this.canvas = canvas;
        this.camera = canvas.camera;
        this.positionTween = null;
        this.quaternionTween = null;
    }

    animate(targetPosition, targetQuaternion, duration = 200) {
        for (let tween of [this.positionTween, this.quaternionTween]) {
            if (tween !== null && tween.isPlaying()) {
                tween.stop();
            }
        }

        this.positionTween = new TWEEN.Tween(this.camera.position)
            .to(targetPosition, duration)
            .onUpdate(() => {
                this.canvas.render();
            })
            .onComplete(() => {
                setTimeout(() => {
                    this.canvas.render();
                });
            })
            .startFromCurrentValues();

        const startQuaternion = new THREE.Quaternion().copy(this.camera.quaternion);
        const currentQuaternion = new THREE.Quaternion();
        const quaternionProgress = {t: 0};
        this.quaternionTween = new TWEEN.Tween(quaternionProgress)
            .to({t: 1}, duration)
            .onUpdate(() => {
                currentQuaternion.slerpQuaternions(startQuaternion, targetQuaternion, quaternionProgress.t);
                this.camera.quaternion.copy(currentQuaternion);
            })
            .start();
        // This does not seem to use the correct slerp calculation:
        // this.quaternionTween = new TWEEN.Tween(this.camera.quaternion)
        //     .to(targetQuaternion, duration)
        //     .startFromCurrentValues();
    }

    animateLookAt(targetPosition, targetLookAt, duration = 200) {
        const rotationMatrix = new THREE.Matrix4();
        rotationMatrix.lookAt(targetPosition, targetLookAt, this.camera.up);
        const targetQuaternion = new THREE.Quaternion();
        targetQuaternion.setFromRotationMatrix(rotationMatrix);
        this.animate(targetPosition, targetQuaternion, duration);
    }

    isPlaying() {
        for (let tween of [this.positionTween, this.quaternionTween]) {
            if (tween !== null && tween.isPlaying()) {
                return true;
            }
        }
        return false;
    }
}
